import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {

  connect() {
      this.element.addEventListener('broadcast', (e) => {
          this.get_data(e)
      })
  }

  get_data(e){
    e.preventDefault()
    e.stopPropagation()

    let params = new URLSearchParams()
    const qQuotationsElement = document.getElementById("q_quotations")

    // Se valida que el parametro exista y que su valor no sea nulo, en caso contrario se asigna cadena vacía
    const safeVal = (id) => {
      const el = document.getElementById(id)
      return (el && el.value != null) ? el.value : ''
    }

    params.append('q_quotations', qQuotationsElement ? qQuotationsElement.value : '')
    params.append('q', safeVal('q'))
    params.append('status', safeVal('status'))
    params.append('product', safeVal('product'))
    params.append('alliance', safeVal('alliance'))

    params.append('q_rev', safeVal('q_rev'))
    params.append('status_rev', safeVal('status_rev'))
    params.append('product_rev', safeVal('product_rev'))
    params.append('alliance_rev', safeVal('alliance_rev'))

    const activeSectionEl = this.element.querySelector('#active_section')
    params.append('active_section', activeSectionEl ? activeSectionEl.value : '')

    get(`${window.location.href.split('?')[0]}?${params}`,{
      responseKind: "turbo-stream"
    })
  }
}
